import {IconButton, ListItem, ListItemSecondaryAction, ListItemText} from '@mui/material';
import {KeyboardArrowRight, Warning} from '@mui/icons-material';
import React from 'react';
import styled from 'styled-components';
import {FONTS} from '@fupa/fupa-uikit';
import {useTheme} from '@mui/styles';
import {useHistory} from 'react-router';
import {useSelector} from 'react-redux';
import {selectCurrentUser} from 'app/hooks/reduxCreateSelectorHooks';

const Hint = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.color};
  font-size: ${FONTS['14']};
`;

const HintText = styled.span`
  margin-left: 0.5rem;
`;

const DeviceManagementLinkRow = () => {
  const {palette} = useTheme();
  const history = useHistory();
  const {notificationPermission, messagingDeviceToken, devices, pushSupport} = useSelector(selectCurrentUser);

  const navigateToDeviceManagement = () => {
    history.push('/my/following/devices');
  };

  const deviceStatus = () => {
    const deviceSubscribed = devices.find(device => device.id === messagingDeviceToken);
    if (messagingDeviceToken && deviceSubscribed) {
      return null;
    }
    let text = '';
    if (!pushSupport) {
      text = 'unterstützt keine Pushes';
    } else if (notificationPermission === 'granted' && !deviceSubscribed) {
      text = 'nicht aktiviert für Pushes. Aktion erforderlich';
    } else {
      const status = {
        default: 'nicht aktiviert für Pushes. Aktion erforderlich',
        deactivated: 'nicht aktiviert für Pushes. Aktion erforderlich',
        denied: 'blockiert Pushes.',
      };
      text = status[notificationPermission];
    }

    return (
      <Hint color={palette.warning.main}>
        <Warning color='inherit' fontSize='inherit' />
        <HintText>Gerät {text}.</HintText>
      </Hint>
    );
  };

  return (
    <ListItem>
      <ListItemText id='switch-push-notifications' primary='Geräte verwalten' secondary={deviceStatus()} />
      <ListItemSecondaryAction>
        <IconButton edge='end' onClick={navigateToDeviceManagement} size='large'>
          <KeyboardArrowRight color={'action'} />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export {DeviceManagementLinkRow};
